export const getToken = () => localStorage.getItem("token");

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || null;
  } catch {
    return null;
  }
};

export const isAuthed = () => Boolean(getToken());

export const clearSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

/**
 * Check if the user is an owner or admin (has full master access).
 */
export const isOwnerOrAdmin = () => {
  const user = getUser();
  if (!user) return false;
  return user.role === "owner" || user.role === "admin";
};

/**
 * Check if the user has a specific permission key.
 * Owners and Admins always return true.
 */
export const hasPermission = (permKey) => {
  const user = getUser();
  if (!user) return false;
  if (user.role === "owner" || user.role === "admin") return true;

  const permissions = Array.isArray(user.permission_names)
    ? user.permission_names
    : Array.isArray(user.permissions)
      ? user.permissions.map((p) => (typeof p === "string" ? p : p.name))
      : [];

  return permissions.includes(permKey);
};

/**
 * Check if the user has AT LEAST ONE of the provided permission keys.
 */
export const hasAnyPermission = (permKeys = []) => {
  const user = getUser();
  if (!user) return false;
  if (user.role === "owner" || user.role === "admin") return true;
  if (!permKeys || permKeys.length === 0) return true;

  const permissions = Array.isArray(user.permission_names)
    ? user.permission_names
    : Array.isArray(user.permissions)
      ? user.permissions.map((p) => (typeof p === "string" ? p : p.name))
      : [];

  return permKeys.some((key) => permissions.includes(key));
};

/**
 * Compute the default accessible landing route for the current user based on permissions.
 */
export const getDefaultRoute = () => {
  const user = getUser();
  if (!user) return "/login";
  if (user.role === "owner" || user.role === "admin") return "/dashboard";

  if (hasAnyPermission(["r_message", "s_message"])) return "/chat";
  if (hasAnyPermission(["r_campaign", "crud_campaign"])) return "/campaigns";
  if (hasAnyPermission(["r_recipient", "crud_recipient"])) return "/contact";
  if (hasAnyPermission(["r_template", "crud_template"])) return "/template";
  if (hasAnyPermission(["r_account", "crud_account"])) return "/account";
  return "/profile";
};
